import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";
// import { log } from "lib/helpers/helpers.js";

function Loading() {
	return (
		<div className="map__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}

const USAMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		// CONGRESSIONAL_DISTRICT_MAP
		usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/us_map.js"),
		// usaMapObject: () =>
		// 	import(/* webpackChunkName: "map" */ "static/maps/jsMaps/US_flatTop.js"),
		// usaMapObject: () => import(/* webpackChunkName: "map" */ "lib/maps/usMap--texas23-alt.js"),
		// reactSimpleMaps: () => import(/* webpackChunkName: "map" */ "react-simple-maps"),
		// CONGRESSIONAL_DISTRICT_MAP
		usStates: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/blob.js"),
		// usStates: () =>
		// 	import(/* webpackChunkName: "map" */ "static/maps/jsMaps/congressionalBlob.js"),
		// usStates: () => import(/* webpackChunkName: "map" */ "static/maps/counties/blob.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexUSCongressional.js"),
		baseIcon: () => import(/* webpackChunkName: "map" */ "lib/maps/tinyUSA.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const usStates = loaded.usStates.default;
		const mapIndex = loaded.mapIndex.default;
		const baseIcon = loaded.baseIcon.default;
		const usaMapObject = loaded.usaMapObject.default;
		// const { reactSimpleMaps } = loaded;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				// reactSimpleMaps={reactSimpleMaps}
				baseIcon={baseIcon}
				baseMapObject={usaMapObject}
				loaderID="USAMapLoader"
				states={usStates}
				mapIndex={mapIndex}
				// CONGRESSIONAL_DISTRICT_MAP
				clickableStates={[]} // "06"  to enable a clickable California, "48" for Texas
				// clickableStates={[
				// 	"01",
				// 	"02",
				// 	"04",
				// 	"05",
				// 	"06",
				// 	"08",
				// 	"09",
				// 	"10",
				// 	"11",
				// 	"12",
				// 	"13",
				// 	"15",
				// 	"16",
				// 	"17",
				// 	"18",
				// 	"19",
				// 	"20",
				// 	"21",
				// 	"22",
				// 	"23",
				// 	"24",
				// 	"25",
				// 	"26",
				// 	"27",
				// 	"28",
				// 	"29",
				// 	"30",
				// 	"31",
				// 	"32",
				// 	"33",
				// 	"34",
				// 	"35",
				// 	"36",
				// 	"37",
				// 	"38",
				// 	"39",
				// 	"40",
				// 	"41",
				// 	"42",
				// 	"44",
				// 	"45",
				// 	"46",
				// 	"47",
				// 	"48",
				// 	"49",
				// 	"50",
				// 	"51",
				// 	"53",
				// 	"54",
				// 	"55",
				// 	"56",
				// ]}
				// highlightable={[{ name: "Texas 23rd", geoState: "texas23" }]}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				activeNarrativeData={props.activeNarrativeData}
				clearMap={actions.clearMap}
				mapHighlightDisabled={false}
				mapId="base"
				subtractFromHeight={360}
				// actions
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default USAMapLoader;
